module.exports = __webpack_public_path__ + "static/media/filter.ba70925b.png";